import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ArticleService {
    constructor(private http: HttpClient) { }

    getPageData(pageName: string) {
        const apiUrl = `${environment.apiUrl}api/v1/get-article/?article_for=school&source=${pageName}`;
        return this.http.get(apiUrl);
    }
    getPageTeacherData(pageName: string) {
        const apiUrl = `${environment.apiUrl}api/v1/get-article/?article_for=teacher&source=${pageName}`;
        return this.http.get(apiUrl);
    }
}   